
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AiAgentsPage = lazy(() => import('../pages/ai-agents/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const SecurityEthicsPage = lazy(() => import('../pages/security-ethics/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const WhoThisIsForPage = lazy(() => import('../pages/who-this-is-for/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const MethodologyPage = lazy(() => import('../pages/methodology/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const DisclosurePage = lazy(() => import('../pages/disclosure/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
import ClientPortalPage from '../pages/client-portal/page';
import ClientRegistrationPage from '../pages/client-registration/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/ai-agents',
    element: <AiAgentsPage />
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />
  },
  {
    path: '/security-ethics',
    element: <SecurityEthicsPage />
  },
  {
    path: '/who-this-is-for',
    element: <WhoThisIsForPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/faq',
    element: <FaqPage />
  },
  {
    path: '/methodology',
    element: <MethodologyPage />
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />
  },
  {
    path: '/disclosure',
    element: <DisclosurePage />
  },
  {
    path: '/client-portal',
    element: <ClientPortalPage />
  },
  {
    path: '/client-registration',
    element: <ClientRegistrationPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
